<template>
  <div class="base-info-warpper">
    <!-- 显示的标签的 标题和值 -->
    <div class="base-title">{{title}}</div>
    <div v-show="!edit" class="info-value box_f1">{{infoValue}}</div>
    <!-- 移除按钮 -->
    <div v-show="!edit && currentId && clearable" class="btn-out" @click="clearZone">移出{{title}}</div>
    <!-- 普通输入框 -->
    <Input
      v-if="edit && model=='input'"
      clearable
      v-model="inputValue"
      :type="inputType"
      :maxlength="maxlength"
      :placeholder="placeholder"
      style="max-width: 875px;"
    />
    <!-- 下拉 -->
    <Select
      v-else-if="edit && model=='select'"
      v-model="selectId"
      :placeholder="placeholder"
      :label-in-value="true"
      :multiple="multiple"
      :disabled="disabled"
      style="max-width: 875px;"
    >
      <!-- 层级下拉 -->
      <Option v-for="item in selectList" :key="item.value" :value="item.value">{{item.label}}</Option>
    </Select>
    <!-- <i-form> -->
    <select-admin-region
      v-else-if="edit && model=='cascader'"
      ref="region"
      @communityChange="communityChange"
      :cascadePath="path"
    ></select-admin-region>
    <!-- </i-form> -->
  </div>
</template>

<script>
import selectAdminRegion from "../../../components/selectAdminRegion";
export default {
  mounted() {},
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    title: String,
    infoValue: {
      type: String,
      default: ""
    }, // 没有默认值 一开始不会触发watch
    model: {
      type: String,
      default: "input"
    },
    placeholder: String,
    selectList: Array,
    currentId: {
      type: null,
      default: ""
    }, // 字符串 或者数组
    multiple: Boolean, // 下拉是否可以多选
    clearable: Boolean,
    disabled: Boolean,
    inputType: {
      type: String,
      default: "text"
    }, // input 的类型
    path: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      inputValue: "",
      selectId: "",
      maxlength: 140 // input 输入框的最大数字限制
    };
  },
  watch: {
    infoValue: {
      handler(newval) {
        this.inputValue = newval;
      },
      immediate: true
    },
    currentId: {
      handler(newVal) {
        // console.log(newVal)
        this.selectId = newVal;
      },
      immediate: true
    }
  },
  methods: {
    getValue() {
      return this.model == "input" && this.inputValue;
    },
    getSelectedId() {
      // 多选模式返回
      if (this.multiple) {
        return this.selectId || [];
      }
      // 默认返回
      return this.selectId;
    },
    clearZone() {
      this.$emit("clearZone", { id: this.selectId, title: this.title });
    },
    communityChange(value) {
      this.$emit("casChange", value);
    }
  },
  components: {
    selectAdminRegion
  }
};
</script>

<style lang="less" scoped>
.base-info-warpper {
  display: flex;
  align-items: center;
}
.base-title {
  // font-size: 16px;
  color: #666;
  margin-right: 10px;
  white-space: nowrap;
  min-width: 4em;
  text-align: right;
}
.info-value {
  color: #999;
  font-size: 12px;
}
.btn-out {
  height: 28px;
  line-height: 28px;
  width: 90px;
  text-align: center;
  background-color: #f9fafa;
  border-radius: 4px;
  color: #4b4b4b;
  border: 1px solid #dedede;
  cursor: pointer;
}
</style>

